import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import Sidebar from './components/shell/Sidebar';
import './App.css';

// Lazy load components that aren't needed on initial page load
const PhotographyPage = lazy(() => import('./components/PhotographyPage'));
const Projects = lazy(() => import('./components/Projects'));
const MapPage = lazy(() => import('./components/MapPage'));
const StatsPage = lazy(() => import('./components/StatsPage'));
const AuroraPage = lazy(() => import('./components/AuroraPage'));
const MoonPage = lazy(() => import('./components/MoonPage'));
const PlanetPage = lazy(() => import('./components/PlanetPage'));
const AuroraGame = lazy(() => import('./components/game/AuroraGame'));
const ConnectionsGame = lazy(() => import('./components/ConnectionsGame'));
// Password-gated admin tool — deliberately not linked from the nav.
const ExportPage = lazy(() => import('./components/ExportPage'));

// Loading fallback component
const PageLoader = () => (
  <div className="page-loader">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

// Sits before the routes so its effect runs first, which leaves a page free to
// put you back where you were -- photography does, when you return from an album.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Sidebar />
        <main className="content">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/photography" element={<PhotographyPage />} />
              <Route path="/photography/:place" element={<PhotographyPage />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/stats" element={<StatsPage />} />
              <Route path="/aurora" element={<AuroraPage />} />
              <Route path="/moon" element={<MoonPage />} />
              <Route path="/planets" element={<PlanetPage />} />
              <Route path="/game" element={<AuroraGame />} />
              <Route path="/connections" element={<ConnectionsGame />} />
              <Route path="/export" element={<ExportPage />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;
